import { motion } from "framer-motion";

import {
  PreTaskQuestionForm,
  type PretaskData,
} from "../../components/ui/PreTaskModal";
import type { PreTaskQuestion } from "../../types";
import { cardContentVariants, detailReveal } from "./motion";
type PreTaskCardProps = {
  onCancel: () => void;
  onSubmit: (data: PretaskData) => void;
  questions: PreTaskQuestion[];
};

export function PreTaskCard({
  onCancel,
  onSubmit,
  questions,
}: PreTaskCardProps) {
  return (
    <motion.article className="task-reveal-card" variants={cardContentVariants}>
      <motion.div className="task-reveal-card__top" variants={detailReveal}>
        <div>
          <motion.div
            className="task-reveal-card__eyebrow"
            variants={detailReveal}
          >
            Pretask
          </motion.div>
          <motion.h1
            className="task-reveal-card__title title-lg"
            variants={detailReveal}
          >
            Before you start...
          </motion.h1>
          {/* <motion.p className="task-reveal-card__subtitle" variants={detailReveal}>
            Answer these to launch your next task.
          </motion.p> */}
        </div>
      </motion.div>

      <motion.div variants={detailReveal} style={{ marginTop: "1rem" }}>
        <PreTaskQuestionForm
          onCancel={onCancel}
          onSubmit={onSubmit}
          questions={questions}
        />
      </motion.div>
    </motion.article>
  );
}
